import ChallengePageChart from './ChallengePageChart';

export default ChallengePageChart;
